<template>
  <Login/>
  <footer></footer>
</template>

<script>
import firebase from 'firebase'
import Login from '@/components/Login.vue'
import { mapActions } from 'vuex'
export default {
  name: 'Admin',
  components: {
    Login
  },
  created() {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.setLoginUser(user)
        this.$router.push({ name: 'AdminHome' }, () => {})
      } else {
        this.deleteLoginUser()
        this.$router.push({ name: 'Admin' }, () => {})
      }
    })
  },
  methods:{
    ...mapActions(['setLoginUser','deleteLoginUser']),
  }
}
</script>
